import MidTermFeatureBanner from '@/components/houses/_reusable/houseInfo/basicInfo/midTermFeatureBanner/MidTermFeatureBanner';
import noPrePayment from '@/public/images/product/midterm-banner/no-prepayment.svg';
import possibilityOfVisiting from '@/public/images/product/midterm-banner/possibility-of-visiting.svg';
import fullFacilities from '@/public/images/product/midterm-banner/full-facilities.svg';
import weeklyCleaning from '@/public/images/product/midterm-banner/hugeicons_cleaning-bucket.svg';
import hroughoutTheCity from '@/public/images/product/midterm-banner/hugeicons_maps-location.svg';
import costEffective from '@/public/images/product/midterm-banner/cost-effective.svg';
import Box from '@/components/UI/box/Box';
import styles from './MidTermBannerFeatures.module.scss';
import useDevice from '@/hooks/useDevice';
const FeatureItemsMobile = [{
  icon: noPrePayment,
  title: 'بدون ودیعه'
}, {
  icon: weeklyCleaning,
  title: 'نظافت هفتگی'
}, {
  icon: possibilityOfVisiting,
  title: 'امکان بازدید'
}, {
  icon: fullFacilities,
  title: 'امکانات کامل'
}];
const FeatureItemsDesktop = [{
  icon: noPrePayment,
  title: 'بدون ودیعه'
}, {
  icon: hroughoutTheCity,
  title: 'در تمام نقاط شهر'
}, {
  icon: costEffective,
  title: 'مقرون به صرفه'
}, {
  icon: possibilityOfVisiting,
  title: 'امکان بازدید'
}, {
  icon: fullFacilities,
  title: 'امکانات کامل'
}, {
  icon: weeklyCleaning,
  title: 'نظافت هفتگی'
}];
const MidTermBannerFeatures = () => {
  const {
    isMobile
  } = useDevice();
  return <Box className={styles['banner-container']} data-sentry-element="Box" data-sentry-component="MidTermBannerFeatures" data-sentry-source-file="MidTermBannerFeatures.tsx">
      <MidTermFeatureBanner features={isMobile ? FeatureItemsMobile : FeatureItemsDesktop} data-sentry-element="MidTermFeatureBanner" data-sentry-source-file="MidTermBannerFeatures.tsx" />
    </Box>;
};
export default MidTermBannerFeatures;